import React from 'react';
import { AppBar, Button } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useStyles } from './styles';

interface Props {
  forwardEnabled: boolean;
  forwardLink?: string;
  backwardLink: string;
}

export const Footer = (props: Props) => {
  const classes = useStyles();
  const [state, toggle] = React.useState(true);
  const history = useHistory();

  React.useEffect(() => {
    toggle(!state);
  }, [props.forwardEnabled]);

  return (
    <AppBar className={classes.appBar} color="inherit">
      <div style={{ display: 'inline-block' }}>
        <Button
          className={classes.backButton}
          size={window.screen.width < 700 ? 'small' : 'large'}
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon style={{ color: 'white', marginRight: 5 }} />
          Back
        </Button>
        {props.forwardLink && (
          <Link to={props.forwardLink}>
            <Button
              variant="contained"
              className={props.forwardEnabled ? classes.nextButton : classes.disabledButton}
              disabled={!props.forwardEnabled}
              size={window.screen.width < 700 ? 'small' : 'large'}
            >
              Next
              <ArrowForwardIcon style={{ color: 'white', marginLeft: 5 }} />
            </Button>
          </Link>
        )}
      </div>
    </AppBar>
  );
};
